export const controlledRightsList = [
  {label: 'CC BY 4.0 Attribution', value: 'CC_BY_4_0_ATTRIBUTION'},
  {label: 'CC BY-ND 4.0 Attribution-NoDerivs', value: 'CC_BY_ND_4_0_ATTRIBUTION_NO_DERIVS'},
  {label: 'CC BY-SA 4.0 Attribution-ShareAlike', value: 'CC_BY_SA_4_0_ATTRIBUTION_SHARE_ALIKE'},
  {label: 'CC BY-NC 4.0 Attribution-NonCommercial', value: 'CC_BY_NC_4_0_ATTRIBUTION_NON_COMMERCIAL'},
  {label: 'CC BY-NC-SA 4.0 Attribution-NonCommercial-ShareAlike', value: 'CC_BY_NC_SA_4_0_ATTRIBUTION_NON_COMMERCIAL_SHARE_ALIKE'},
  {label: 'CC BY-NC-ND 4.0 Attribution-NonCommercial-NoDerivs', value: 'CC_BY_NC_ND_4_0_ATTRIBUTION_NON_COMMERCIAL_NO_DERIVS'},
  {label: 'CC0 1.0 Universal Public Domain Dedication', value: 'CC_0_1_0_UNIVERSAL_PUBLIC_DOMAIN_DEDICATION'},
  {label: 'All rights reserved', value: 'ALL_RIGHTS_RESERVED'},
  {label: 'Other', value: 'OTHER'}
]
